import { defineComponent as _defineComponent } from 'vue'
import { useRoute, useContext } from '@nuxtjs/composition-api';
import { ref, watch } from 'vue';

interface Props {
  menu: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeaderMobile',
  props: {
    menu: null
  },
  setup(__props: any) {

const { $config } = useContext();

const { logo, logoLight } = $config;



const isMobileMenuOpen = ref(false);
const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const close = () => {
  isMobileMenuOpen.value = false;
};

const isSearchOpen = ref(false);
const toggleSearch = () => {
  isSearchOpen.value = !isSearchOpen.value;
};

const route = useRoute();
watch(
  () => route.value.path,
  () => {
    close();
  },
);

return { __sfc: true,$config, logo, logoLight, isMobileMenuOpen, toggleMobileMenu, close, isSearchOpen, toggleSearch, route }
}

})